var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"content"},[_c('span',{staticClass:"text"},[_vm._v("欢迎使用砀山县零工市场商家端")]),_c('img',{staticClass:"bg-img",attrs:{"src":require("../../assets/home/bg.png"),"alt":"","draggable":"false"}})])])
}]

export { render, staticRenderFns }